import { FilterOps, ILeafFilterClause, IStringArrayValuedFieldFilterClause, IStringValuedFilterClause } from '../../ts/ServerApi/types/IFilterClause';

/**
 * Finds the "search" filter among the filter clauses, if it exists, and gets its value.
 * If not present, returns null.
 */
export function getSearchFilter(filterClauses: ILeafFilterClause[]): string | null {
  const searchFilter = filterClauses.find(clause => clause.operator === FilterOps.matches) as IStringValuedFilterClause;
  return (searchFilter && searchFilter.value) || null;
}

/**
 * Finds the "in" filter among the filter clauses, if it exists, and gets its values.
 * If not present, returns null.
 */
export function getInFilter(filterClauses: ILeafFilterClause[]): ReadonlyArray<string> | null {
  const idsFilter = filterClauses.find(clause => clause.operator === FilterOps.inArray) as IStringArrayValuedFieldFilterClause;
  return (idsFilter && idsFilter.values) || null;
}
